import { styled } from '@/styled-system/jsx';
import { Button } from '@zillow/constellation-10';

export const HiddenButton = styled(Button, {
  base: {
    display: { base: 'block', md: 'none' },
  },
});

export const HeroButton = styled(Button, {
  base: {
    width: '187px',
  },
});

export const FooterButton = styled(Button, {
  base: {
    width: { base: 'auto', lg: '175px' },
  },
  variants: {
    productIntroType: {
      sohIllustrative: {
        width: { lg: '245px' },
      },
    },
  },
});
